'use strict';

DoohApps
.directive('validChars', function () {
    return {
        require: 'ngModel',
        link: function (scope, element, attrs, ngModelCtrl) {
            //allow only alpha numeric values and ['-', '_', '\', '.']
            var keyCodes = [13, 32, 106, 107, 110, 111, 186, 187, 188, 191, 192, 219, 221, 222]; //9
            var shiftKeyCodes = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 190, 220];
            element.bind('keydown', function (event) {
                if ($.inArray(event.which, keyCodes) !== -1 || (event.shiftKey && $.inArray(event.which, shiftKeyCodes) !== -1)) {
                    event.preventDefault();
                }

                //Wanted to impelemt this in case the result was pasted, but it's kind of overkill to catch paste event atm. So this will remove any illegal characters on every keydown...
                if (ngModelCtrl.$viewValue != undefined) {
                    ngModelCtrl.$setViewValue(ngModelCtrl.$viewValue.trim().replace(/[^a-zA-Z0-9\.\-\_\\]/g, ''));
                    ngModelCtrl.$render();
                }
            });
        }
    };
});